var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isBaiduMap && _vm.showbutton,
      expression: "!isBaiduMap && showbutton"
    }],
    staticClass: "no-native"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": _vm.jumpToMap
    }
  }, [_c('span', [_vm._v("百度地图APP内打开")]), _c('wxOpenButton', {
    attrs: {
      "app-link": _vm.jumpWxAppUrl
    },
    on: {
      "failJump": _vm.jumpToMap
    }
  })], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };